import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./userNavbar.css";
import LogoutButton from "../../private/logout/logout.tsx";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Drawer, IconButton } from "@mui/material";
import { logoutUser } from "../../../services/authAPI.js";

const UserNavbar = ({ activeTab, setActiveTab }: any) => {
  const user = useSelector((state: any) => state.auth.user);

  const isAdmin = user?.email === "svenugoban1996@gmail.com";

  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    try {
      await logoutUser(refreshToken);
    } catch (e) { }

    localStorage.clear();
    window.location.href = "/";
  };

  const menuItems = [
    { key: "members", label: "Active Members" },
    { key: "requests", label: "Sent Requests" },
    { key: "profile", label: "My Profile" },
  ];

  if (isAdmin) {
    menuItems.push({
      key: "admin",
      label: "Admin Panel",
    });
  }

  return (
    <>
      <div className='user-navbar'>
        {/* LEFT */}
        <div className='user-navbar-left'>
          <div className='navbar-logo'>
            <div onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
              <img src='/uyirthunai.png' alt='UyirThunai Logo' />
            </div>
            
          </div>
        </div>
        <div className='mobile-menu-toggle'>
          <IconButton onClick={() => setMobileOpen(true)}>
            <MenuIcon />
          </IconButton>
        </div>
        {/* DESKTOP MENU */}
        <div className='user-navbar-center'>
          {menuItems.map((item) => (
            <div
              key={item.key}
              className={`nav-item ${activeTab === item.key ? "active" : ""}`}
              onClick={() => setActiveTab(item.key)}
            >
              {item.label}
            </div>
          ))}
        </div>

        <div className='user-navbar-right'>
          <span className='welcome-text'>Hi, {user?.name}</span>

          <div className='desktop-logout'>
            <LogoutButton />
          </div>
        </div>
      </div>

      {/* MOBILE DRAWER */}
      <Drawer anchor='left' open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <div className='mobile-drawer'>
          <div className='drawer-header'>
            <IconButton onClick={() => setMobileOpen(false)}>
              <CloseIcon />
            </IconButton>
          </div>

          {menuItems.map((item) => (
            <div
              key={item.key}
              className={`mobile-nav-item ${activeTab === item.key ? "active" : ""}`}
              onClick={() => {
                setActiveTab(item.key);
                setMobileOpen(false);
              }}
            >
              {item.label}
            </div>
          ))}

          {/* Logout Menu Item */}
          <div
            className='mobile-nav-item logout-item'
            onClick={() => {
              setMobileOpen(false);
              handleLogout();
            }}
          >
            Logout
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default UserNavbar;
